import { NgModule } from "@angular/core";
import { MenuModule } from "../menu/menu.module";
import { ERTUserComponent } from "./ert-user.component";
import { SharedImportsModule } from "../shared/shared-imports.module";
import { TableControlsComponent } from "../shared/table-controls/table-controls.component";
import { ErtNewUserDetailsComponent } from "./new-user/ert-new-user-details/ert-new-user-details.component";
import { ErtNewUserComponent } from "./new-user/ert-new-user/ert-new-user.component";

const componentList = [
  ERTUserComponent,
  ErtNewUserDetailsComponent,
  ErtNewUserComponent,
];

@NgModule({
  imports: [
    MenuModule,
    SharedImportsModule,
    TableControlsComponent,
  ],
  declarations: [componentList],
})
export class ERTUserModule {}
